<script>
  import Tailwindcss from "../components/Tailwindcss.svelte";

  /* Stores */
  import storeGlobal from "../stores/storeGlobal";

  /* Components */
  import Navbar from "../components/navbar/Navbar.svelte";
  import Footer from "../components/Footer.svelte";
  import ToTop from "../components/BackToTop.svelte";

  /* Colormode control */
  $: window.document.documentElement.classList.toggle( 'mode-dark', $storeGlobal.darkMode );
  $: window.document.documentElement.classList.toggle( 'overflow-hidden', $storeGlobal.showDetails );
</script>

<!-- CSS -->
<Tailwindcss/>

<Navbar/>

<main>
  <slot></slot>
</main>

<ToTop/>
<Footer/>
